import styles from "./MetaRow.module.css";
import MetaCard from "./MetaCard";

function MetaRow({ data = [] }) {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className={styles["meta-row"]}>
      {data.map((metaData, index) => (
        <MetaCard key={index} metaData={metaData} />
      ))}
    </div>
  );
}

export default MetaRow;
